<template>
  <div class="-trend">
    <div class="c_main">
      <div class="inner">
        <nav class="c_pnkz">
          <ul class="c_pnkz_list">
            <li>
              <a class="c_pointer" @click="$router.push({ name: 'Home' })">
                ホーム
              </a>
            </li>
            <li>確認クイズ</li>
          </ul>
        </nav>
        <div>
          <NovelGame />
        </div>
        <div class="pageback">
          <a class="c_txtlink" @click="$router.push({ name: 'Home' })">
            トップに戻る
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NovelGame from "@/components/NovelGame";
export default {
  components: {
    NovelGame
  }
};
</script>

<style scoped>
.pageback {
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
